import '@flecto/ui/assets/fonts.css'

import NextApp, { type AppContext, type AppProps } from 'next/app'
import Head from 'next/head'
import { NuqsAdapter } from 'nuqs/adapters/next/pages'
import React from 'react'
import TagManager from 'react-gtm-module'

import { ScriptClarity } from '@flecto/analytics'
import { QueryProvider } from '@flecto/core'
import { FeatureFlagsProvider } from '@flecto/feature-flags'
import { TranslationProvider } from '@flecto/translations'
import {
  ModalsProvider,
  DrawersProvider,
  MantineThemeProvider,
} from '@flecto/ui'

export default function App({ Component, pageProps }: AppProps) {
  const GTM_ID = process.env.GTM_ID ?? ''
  const GTM_ENABLE = Boolean(process.env.STORE_ENABLE_GTM === '1')
  const MS_CLARITY_ID = process.env.NEXT_PUBLIC_MICROSOFT_CLARITY_ID ?? ''

  if (typeof window !== 'undefined' && GTM_ENABLE) {
    TagManager.initialize({ gtmId: GTM_ID })
  }

  return (
    <>
      <ScriptClarity projectId={MS_CLARITY_ID} />
      <Head>
        <meta charSet='UTF-8' />
        <meta httpEquiv='X-UA-Compatible' content='ie=edge' />
        <meta
          name='viewport'
          content='width=device-width, initial-scale=1, maximum-scale=1'
        />
        <meta name='google' content='notranslate' />
      </Head>
      <QueryProvider>
        <TranslationProvider withBrowserLanguageAsDefault>
          <FeatureFlagsProvider>
            <NuqsAdapter>
              <MantineThemeProvider>
                <ModalsProvider>
                  <DrawersProvider>
                    <Component {...pageProps} />
                  </DrawersProvider>
                </ModalsProvider>
              </MantineThemeProvider>
            </NuqsAdapter>
          </FeatureFlagsProvider>
        </TranslationProvider>
      </QueryProvider>
    </>
  )
}

App.getInitialProps = async (appContext: AppContext) => {
  const appProps = await NextApp.getInitialProps(appContext)
  return {
    ...appProps,
  }
}
